import projectListComponent from './project-list.component';

const projectListModule = angular.module('projectList', [
])
  .component('projectList', projectListComponent)
  .name;

export default projectListModule;
